import SuperRepository from '../superRepository'

export default new (class OfferPartnerTagsRepository extends SuperRepository {
    baseUri() {
        return 'offer_partner_tag'
    }
})()
